import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineBrandStudio = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    fill="none"
    viewBox="0 0 22 22"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.313}
      d="m14.799 13.125.784-1.906a.287.287 0 0 1 .531 0l.785 1.906a3.08 3.08 0 0 0 1.674 1.674l1.906.784a.287.287 0 0 1 0 .531l-1.906.785a3.08 3.08 0 0 0-1.674 1.674l-.785 1.906a.287.287 0 0 1-.53 0l-.785-1.906a3.08 3.08 0 0 0-1.674-1.674l-1.906-.785a.287.287 0 0 1 0-.53l1.906-.785a3.08 3.08 0 0 0 1.674-1.674M.657 10.047q.872-.159 1.79-.16a9.96 9.96 0 0 1 6.39 2.308"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.313}
      d="M7.58 16.041H2.195a1.54 1.54 0 0 1-1.538-1.538V2.195A1.54 1.54 0 0 1 2.195.657h12.308a1.54 1.54 0 0 1 1.538 1.538V7.58"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.313}
      d="M9.503 7.58a1.923 1.923 0 1 0 0-3.847 1.923 1.923 0 0 0 0 3.847"
    />
  </svg>
);
export default SvgStreamlineBrandStudio;
